import { trace } from '../../../configuration/setup/trace';

export const SELECT_POIS_EVENT = 'EVENT_SELECT_POIS';

export type SelectPoisType = string[];

export const selectPoisHandler = (data: SelectPoisType) => {
    trace.debug('Select POIs:', data);
};
